import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonDropdown } from '@dossierhq/design';
import { useContext } from 'react';
import { DossierContext } from '../../contexts/DossierContext.js';
import { filterTypeSpecifications, } from '../../utils/TypeSelectionUtils.js';
export function AdminTypePicker({ className, iconLeft, onTypeSelected, children, ...filter }) {
    const { schema } = useContext(DossierContext);
    let items = [];
    if (schema) {
        items = filterTypeSpecifications(schema, filter).map((it) => ({ id: it.name, name: it.name }));
    }
    return (_jsx(ButtonDropdown, { className: className, iconLeft: iconLeft, items: items, renderItem: (item) => item.name, disabled: !schema || items.length === 0, onItemClick: onTypeSelected ? (item) => onTypeSelected(item.id) : undefined, children: children }));
}
//# sourceMappingURL=AdminTypePicker.js.map